import type { SystemView } from "../types";

export type ExceptionType = "ip" | "domain" | "hash" | "user" | "rule";

export interface SocException {
    id: string;
    name: string;
    type: ExceptionType;
    value: string;
    reason: string;
    expiry: string;
    active: boolean;
}

export const MOCK_SOC_EXCEPTIONS: SocException[] = [
    {
        id: "exc-1",
        name: "Vulnerability Scanner",
        type: "ip",
        value: "10.0.50.10",
        reason: "Internal Nessus scanner triggers false positives",
        expiry: "2026-06-30",
        active: true,
    },
    {
        id: "exc-2",
        name: "Safe Sender Domain",
        type: "domain",
        value: "updates.microsoft.com",
        reason: "Legitimate Microsoft update domain",
        expiry: "2027-01-01",
        active: true,
    },
    {
        id: "exc-3",
        name: "Known Test Hash",
        type: "hash",
        value: "d41d8cd98f00b204e9800998ecf8427e",
        reason: "EICAR test file hash for AV testing",
        expiry: "—",
        active: true,
    },
    {
        id: "exc-4",
        name: "Service Account",
        type: "user",
        value: "svc-backup@corp.local",
        reason: "Automated backup service generates high-volume login events",
        expiry: "2026-12-31",
        active: true,
    },
    {
        id: "exc-5",
        name: "Port Scan Rule",
        type: "rule",
        value: "RULE-PORTSCAN-LOW",
        reason: "Low-rate port scans from monitoring subnet expected",
        expiry: "2026-09-30",
        active: false,
    },
    {
        id: "exc-6",
        name: "Dev Environment",
        type: "ip",
        value: "10.0.100.0/24",
        reason: "Development network generates noisy alerts during testing",
        expiry: "2026-06-30",
        active: true,
    },
];

export type NotificationChannelType = "email" | "slack" | "webhook";

export interface NotificationChannel {
    id: string;
    type: NotificationChannelType;
    target: string;
    severityFilter: ("critical" | "high" | "medium" | "low")[];
    systemFilter: SystemView[];
    active: boolean;
}

export const MOCK_NOTIFICATION_CHANNELS: NotificationChannel[] = [
    {
        id: "nc-1",
        type: "email",
        target: "soc-team@trufflepig.com",
        severityFilter: ["critical", "high"],
        systemFilter: ["soc", "ndr", "mail"],
        active: true,
    },
    {
        id: "nc-2",
        type: "slack",
        target: "#security-alerts",
        severityFilter: ["critical", "high", "medium"],
        systemFilter: ["soc", "ndr", "mail", "ztna", "phishing", "pentests"],
        active: true,
    },
    {
        id: "nc-3",
        type: "webhook",
        target: "https://hooks.example.com/security",
        severityFilter: ["critical"],
        systemFilter: ["soc", "ndr"],
        active: true,
    },
    {
        id: "nc-4",
        type: "email",
        target: "management@trufflepig.com",
        severityFilter: ["critical"],
        systemFilter: ["soc", "pentests"],
        active: false,
    },
    {
        id: "nc-5",
        type: "slack",
        target: "#pentest-findings",
        severityFilter: ["critical", "high", "medium", "low"],
        systemFilter: ["pentests"],
        active: true,
    },
];

export interface UserProfile {
    name: string;
    email: string;
    role: string;
    timezone: string;
    language: string;
    twoFactor: boolean;
}

export const MOCK_PROFILE: UserProfile = {
    name: "Max Mustermann",
    email: "m.mustermann@trufflepig.com",
    role: "Security Operations Manager",
    timezone: "Europe/Berlin",
    language: "de",
    twoFactor: true,
};
